export const DEFAULT_CANCEL_TEXT = 'Cancel';
export const DEFAULT_CONFIRM_TITLE = 'Are you sure?';
export const DEFAULT_CONFIRM_DESCRIPTION = '';
